import {HiX} from "react-icons/hi";
import Links from "./components/Links";
import Logo from "assets/img/logo.png";
import routesWrapper from "routes.js";
import {useMsal} from "@azure/msal-react";

const Sidebar = ({ open, onClose }) => {
  const { instance } = useMsal();

  const filteredRoutes = routesWrapper();

  const handleLogout = async () => {
    try {
      await instance.logoutPopup();
      // navigate("/login");
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
      <div
          className={`fixed top-0 left-0 z-50 flex h-full w-56 flex-col bg-white/90 backdrop-blur-xl border-r border-gray-100 transition-transform duration-300
    ${open ? "translate-x-0" : "-translate-x-full"}`}
      >
        {/* Close Button (Mobile) */}
        <button
            onClick={onClose}
            className="absolute right-4 top-4 xl:hidden text-gray-500 hover:text-gray-800 transition"
        >
          <HiX className="h-5 w-5" />
        </button>

        {/* Logo */}
        <div className="flex items-center gap-3 px-6 pt-8 pb-6">
          <img className="h-8 w-auto" src={Logo} alt="Logo" />
        </div>

        {/* Links */}
        <div className="flex-1 overflow-y-auto px-3">
          <ul className="space-y-1">
            <Links routes={filteredRoutes} />
          </ul>
        </div>

        {/* Bottom Section */}
        <div className="px-4 pb-6">
          <button
              onClick={handleLogout}
              className="w-full rounded-md border border-red-200 text-red-600 text-sm font-medium py-2 hover:bg-red-50 transition"
          >
            Logout
          </button>
        </div>
      </div>
  );
};

export default Sidebar;
